import { Injectable } from "@angular/core";
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";

import { AuthenticationService } from "../services/auth.service";

import { environment } from "../../../environments/environment";
import { AuthfakeauthenticationService } from "../services/authfake.service";

@Injectable({ providedIn: "root" })
export class AuthGuard  {
  user: any;

  constructor(
    private router: Router,
    private authenticationService: AuthenticationService,
    private authFackservice: AuthfakeauthenticationService
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    this.user = this.authenticationService.currentUser();

    if (
      this.user &&
      this.user.jwtToken &&
      new Date(this.user.jwtToken.expiration) > new Date()
    ) {
      // Se a rota tiver perfis configurados (por profileWkf string)
      const expectedProfiles = route.data["profiles"] as string[];
      // Se a rota tiver profileIds configurados (por profile.profileId numérico)
      const expectedProfileIds = route.data["profileIds"] as number[];

      if (
        (!expectedProfiles || expectedProfiles.length === 0) &&
        (!expectedProfileIds || expectedProfileIds.length === 0)
      ) {
        return true; // sem restrição
      }

      const userProfile = this.user.profileWkf;
      const userProfileId = this.user.profile?.profileId;

      const hasProfileAccess =
        expectedProfiles && expectedProfiles.includes(userProfile);
      const hasProfileIdAccess =
        expectedProfileIds && expectedProfileIds.includes(userProfileId);

      if (hasProfileAccess || hasProfileIdAccess) {
        return true;
      } else {
        this.router.navigate(["/no-permission"]);
        return false;
      }
    }

    // não autenticado → login
    this.router.navigate(["/account/login"]);
    return false;
  }
}
